<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>修改密码
      <div class="ml-4 text-button">
        <a v-if="mode==1" class="text-decoration-none" @click="mode=2">短信验证码校验进行修改</a>
        <a v-if="mode==2" class="text-decoration-none" @click="mode=1">输入原密码校验进行修改</a>
      </div>
    </v-card-title>
    <v-card-text>
      <v-form ref="updatePasswordForm" v-if="mode==1">
        <v-row class="mt-2">
          <v-col cols="6">
            <v-text-field validate-on-blur v-model="formData.srcPassword" dense type="password" autocomplete="off" outlined class="rounded-0" label="请输入您当前的登录密码(区分大小写)" :rules="[rules.required]"></v-text-field>
            <v-text-field validate-on-blur v-model="formData.newPassword" dense type="password" autocomplete="off" outlined class="rounded-0" label="请输入新密码(区分大小写)" :rules="[rules.required,rules.password]"></v-text-field>
            <v-text-field validate-on-blur v-model="formData.reNewPassword" dense type="password" autocomplete="off" outlined class="rounded-0" label="请再次输入新密码(区分大小写)" :rules="[rules.required,rules.password,rules.same]"></v-text-field>
          </v-col>
        </v-row>
      </v-form>

      <v-form ref="updatePasswordForm2" v-if="mode==2">
        <v-row class="mt-2">
          <v-col cols="6">
            <int-editor ref="item_smsCode" validate-on-blur v-model="formData2.smsCode" dense label="验证码" outlined class="rounded-0" autocomplete="off" :rules="[rules.required]">
              <template v-slot:append>
                <div style="margin-top:-3px;">
                  <v-btn color="primary" small class="caption" :disabled="smsCodeDisabled" elevation=0 @click="onGetUpdatePasswordSmsCode">{{smsCodeText}}</v-btn>
                </div>
              </template>
            </int-editor>
            <v-text-field validate-on-blur v-model="formData2.newPassword" dense type="password" autocomplete="off" outlined class="rounded-0" label="请输入新密码(区分大小写)" :rules="[rules.required,rules.password]"></v-text-field>
            <v-text-field validate-on-blur v-model="formData2.reNewPassword" dense type="password" autocomplete="off" outlined class="rounded-0" label="请再次输入新密码(区分大小写)" :rules="[rules.required,rules.password,rules.same2]"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="pl-4">
      <v-row class="mb-6">
        <v-col cols="6">
          <v-btn @click="onUpdatePassword" large tile color="primary" v-one-click>提 交</v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
/* eslint-disable no-console */
import md5 from 'md5';
import { getUpdatePasswordSmsCode, updatePassword } from '@/plugins/api';
import { required, password } from '@/plugins/rules';
export default {
  data () {
    return {
      mode: 1, // 1: 根据原始密码进行修改, 2: 根据短信验证码进行修改
      formData: { password: '', newPassword: '', reNewPassword: '' },
      formData2: { smsCode: null, newPassword: '', reNewPassword: '' },
      smsCodeText: '获取验证码',
      smsCodeDisabled: false,
      rules: {
        required: required(), password: password(),
        same: (v) => {
          return (v && v == this.formData.newPassword) || '两次密码输入不一致';
        },
        same2: (v) => {
          return (v && v == this.formData2.newPassword) || '两次密码输入不一致';
        }
      }
    }
  },
  created () { },
  methods: {

    onUpdatePassword () {
      if (this.mode == 2) {
        this.onUpdatePasswordBySmsCode()
        return
      }
      let valid = this.$refs.updatePasswordForm.validate();
      if (!valid) return;
      let dto = {
        mode: this.mode,
        srcPassword: md5(this.formData.srcPassword),
        password: md5(this.formData.newPassword)
      };
      updatePassword(dto).then(() => {
        this.$message.success('密码修改成功');
        this.formData = { password: '', newPassword: '', reNewPassword: '' }
      })
    },

    onGetUpdatePasswordSmsCode () {
      this.smsCodeDisabled = true;
      let i = 60;
      let removeTimer = () => {
        clearInterval(smsCodeTimer);
        smsCodeTimer = undefined;
        this.smsCodeDisabled = false;
        this.smsCodeText = '获取验证码';
      }
      let smsCodeTimer = setInterval(() => {
        if (i < 0) removeTimer();
        else this.smsCodeText = `重新发送${i--}`;
      }, 1000);
      getUpdatePasswordSmsCode().then((res) => {
        if (res.status < 0) {
          this.$emit('error', res.message);
          removeTimer();
          return;
        }
        this.$message.success('验证码已发送，请注意查收');
      })
    },

    onUpdatePasswordBySmsCode () {
      let valid = this.$refs.updatePasswordForm2.validate();
      if (!valid) return;
      let dto = {
        mode: this.mode,
        smsCode: this.formData2.smsCode,
        password: md5(this.formData.newPassword)
      };
      updatePassword(dto).then(() => {
        this.$message.success('密码修改成功');
        this.formData2 = { smsCode: null, newPassword: '', reNewPassword: '' }
      })
    }
  }
}
</script>